import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Text from './components/Text';
import Button from './components/Button';
import { Section, Container, Box, Video } from '@miro-site/core';
import { LazyImageAdapter } from '@miro-site/components_utils';
import styled, { useTheme, css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MEDIA_SIZES = {
  xl: ['100%', 800],
  l: '100%',
  m: ['100%', '550px']
};
var VideoBg = styled.div.withConfig({
  displayName: "SuperComponent__VideoBg",
  componentId: "sc-s0qv15-0"
})(["position:absolute;max-width:100%;max-height:100%;height:100%;width:100%;top:0;left:0;z-index:-100;overflow:hidden;"]);
var SuperGrid = styled(Box).attrs({
  $mx: [null, -10]
}).withConfig({
  displayName: "SuperComponent__SuperGrid",
  componentId: "sc-s0qv15-1"
})(["display:flex;flex-wrap:wrap;flex-direction:row;justify-content:space-between;align-items:center;", " ", " & > ", "{", "}"], function (_ref) {
  var $isReversed = _ref.$isReversed;
  return $isReversed && css(["flex-direction:row-reverse;"]);
}, function (_ref2) {
  var $isStacked = _ref2.$isStacked;
  return $isStacked && css(["flex-direction:column;"]);
}, Box, function (_ref3) {
  var theme = _ref3.theme;
  return theme.normalizeStyles({
    paddingLeft: [null, 10],
    paddingRight: [null, 10]
  });
});

var SuperComponent = function SuperComponent(_ref4) {
  var _background$mobileIma, _background$mobileIma2, _background$desktopIm, _background$desktopIm2;

  var layout = _ref4.layout,
      headline = _ref4.headline,
      subtitle = _ref4.subtitle,
      button = _ref4.button,
      additionalButton = _ref4.additionalButton,
      image = _ref4.image,
      video = _ref4.video,
      _ref4$background = _ref4.background,
      background = _ref4$background === void 0 ? {} : _ref4$background,
      _ref4$spaces = _ref4.spaces,
      spaces = _ref4$spaces === void 0 ? {} : _ref4$spaces;
  var theme = useTheme();
  var colors = theme.colors;

  var getPaddingValue = function getPaddingValue(padding) {
    return theme.spaces[padding] || padding;
  };

  var maxWidth = layout.maxWidth == 'article' ? [null, 720] : layout.maxWidth;
  var mx = layout.maxWidth == 'article' || background.videoId ? [null, 'auto'] : undefined;
  var hasMedia = image || video; // TODO: we need to validate these values before passing to the styles, some special characters can break stuff

  var styles = {
    backgroundColor: colors[background.color] || background.color,
    backgroundSize: [background.mobileSize, background.size],
    backgroundPosition: [background.mobilePosition, background.position],
    backgroundRepeat: 'no-repeat',
    backgroundImage: [((_background$mobileIma = background.mobileImage) === null || _background$mobileIma === void 0 ? void 0 : _background$mobileIma.src) && "url(\"".concat((_background$mobileIma2 = background.mobileImage) === null || _background$mobileIma2 === void 0 ? void 0 : _background$mobileIma2.src, "\")"), ((_background$desktopIm = background.desktopImage) === null || _background$desktopIm === void 0 ? void 0 : _background$desktopIm.src) && "url(\"".concat((_background$desktopIm2 = background.desktopImage) === null || _background$desktopIm2 === void 0 ? void 0 : _background$desktopIm2.src, "\")")],
    paddingTop: [getPaddingValue(spaces.mobileTopPadding), getPaddingValue(spaces.desktopTopPadding)],
    paddingBottom: [getPaddingValue(spaces.mobileBottomPadding), getPaddingValue(spaces.desktopBottomPadding)],
    paddingRight: [getPaddingValue(spaces.mobileRightPadding), getPaddingValue(spaces.desktopRightPadding)],
    paddingLeft: [getPaddingValue(spaces.mobileLeftPadding), getPaddingValue(spaces.desktopLeftPadding)],
    maxWidth: maxWidth,
    width: layout === null || layout === void 0 ? void 0 : layout.width,
    height: layout === null || layout === void 0 ? void 0 : layout.height
  };

  if (background.videoId) {
    Object.assign(styles, {
      position: 'relative'
    });
  }

  var GAP_FOR_ONE_COLUMN = 88;
  var isSmallestMediaSize = layout.mediaSize == 'm';
  var textContentColumnStyles = {
    width: '100%'
  };
  var mediaColumnStyles = {
    width: '100%'
  };

  if (layout.columns > 1) {
    textContentColumnStyles = {
      maxWidth: ['100%', isSmallestMediaSize ? '50%' : '33.33%'],
      flex: ['0 0 100%', isSmallestMediaSize ? '0 0 50%' : '0 0 33.33%']
    };
    mediaColumnStyles = {
      maxWidth: ['100%', isSmallestMediaSize ? '50%' : '58.33%'],
      flex: ['0 0 100%', isSmallestMediaSize ? '0 0 50%' : '0 0 58.33%']
    };
  }

  var columns = [/*#__PURE__*/_jsxs(Box, {
    $styles: _objectSpread({
      textAlign: layout.contentAlignment
    }, textContentColumnStyles),
    $mb: hasMedia ? layout.columns == 1 ? GAP_FOR_ONE_COLUMN : [GAP_FOR_ONE_COLUMN, null] : null,
    children: [(headline === null || headline === void 0 ? void 0 : headline.children) && /*#__PURE__*/_jsx(Box, {
      $mb: theme.spaces.md,
      children: /*#__PURE__*/_jsx(Text, _objectSpread({}, headline))
    }), (subtitle === null || subtitle === void 0 ? void 0 : subtitle.children) && /*#__PURE__*/_jsx(Box, {
      $mb: theme.spaces.md * 2,
      children: /*#__PURE__*/_jsx(Text, _objectSpread({}, subtitle))
    }), button && /*#__PURE__*/_jsx(Button, _objectSpread({}, button)), additionalButton && /*#__PURE__*/_jsx(Button, _objectSpread({}, additionalButton))]
  }, "text-column")];

  if (hasMedia) {
    columns.push( /*#__PURE__*/_jsxs(Box, {
      $styles: _objectSpread({}, mediaColumnStyles),
      children: [image && /*#__PURE__*/_jsx(Box, {
        $styles: {
          overflow: 'hidden',
          width: MEDIA_SIZES[layout.mediaSize]
        },
        children: /*#__PURE__*/_jsx(LazyImageAdapter, {
          assets: image
        })
      }), (video === null || video === void 0 ? void 0 : video.id) && /*#__PURE__*/_jsx(Box, {
        $styles: {
          overflow: 'hidden',
          width: MEDIA_SIZES[layout.mediaSize]
        },
        children: /*#__PURE__*/_jsx(Video, {
          id: video.id,
          thumbnail: video.thumbnail
        })
      })]
    }, "media"));
  }

  return /*#__PURE__*/_jsxs(Section, {
    $withLastChildPadding: false,
    $mx: mx,
    $styles: styles,
    children: [background.videoId && /*#__PURE__*/_jsx(VideoBg, {
      children: /*#__PURE__*/_jsx(Video, {
        id: background.videoId,
        options: {
          playlistLoop: true,
          fitStrategy: 'fill'
        }
      })
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(SuperGrid, {
        $isStacked: layout.columns == 1,
        $isReversed: layout.textPosition == 'right',
        children: columns
      })
    })]
  });
};

export default SuperComponent;